export const checkEmail = (value) => {
    if (value) 
      return !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(value) ? 'Invalid Email' : '';
    
    return '';
  };

export const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email);
  };

export const checkPassword = (password) => {
  if (!password) return "";
  
  // Check minimum length
  if (password.length < 8) {
    return "Password must be at least 8 characters long.";
  }
  
  const hasLetterAndNumber = /(?=.*[a-zA-Z])(?=.*\d)/.test(password);
  const hasSpecialChar = /(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/.test(password);
  const hasUpperCase = /(?=.*[A-Z])/.test(password);
  const hasLowerCase = /(?=.*[a-z])/.test(password);

  if (!hasLetterAndNumber) {
    return "Password must contain a mix of letters and numbers.";
  }
  if (!hasSpecialChar) {
    return "Password must contain at least 1 special character.";
  }
  if (!hasUpperCase || !hasLowerCase) {
    return "Password must contain at least one lowercase and one uppercase letter.";
  }
  
  return "";
};
  
  export default '';